/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain as PlaceOrderChain,
    SendTracking,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { getDataLayer } from "@monsma/App/Utilities/DataLayer";

export const _GaPlaceOrder: any = (props: any) => {
    const state = props.getState();

    if (state && state["xGA"] && state["xGA"]["cartToBuyRateEvent"]) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const { apiResult } = props;

        const data = {
            event: state["xGA"]["cartToBuyRateEventName"] || "purchase",
            ecommerce: {
                purchase: {
                    actionField: {
                        id: apiResult.cart.orderNumber,
                        affiliation: apiResult.billTo.companyName,
                        revenue: apiResult.cart.orderGrandTotal,
                        tax: apiResult.cart.totalTax,
                        shipping: apiResult.cart.shippingAndHandling,
                    },
                    products: <any>[],
                },
            },
        };

        props.cartToUpdate.cartLines.forEach((cartLine: any) => {
            const GAData = {
                name: cartLine.shortDescription,
                id: cartLine.erpNumber,
                price: cartLine.pricing.unitNetPrice,
                quantity: cartLine.qtyOrdered,
            } as any;

            if (state["xGA"]["productBrand"]) {
                GAData["brand"] = cartLine.brand?.name || "";
            }

            if (state["xGA"]["productCategory"]) {
                GAData["category"] = cartLine.properties["category"] || "";
            }

            data.ecommerce.purchase.products.push(GAData);
        });

        dataLayer.push(data);
    }
};

replaceInChain(PlaceOrderChain, SendTracking, _GaPlaceOrder);
